import { input, output } from '@b2b/types/core';
import angular from 'angular';
import type { LimitsViolation } from '../../services/salesRules/limits-validation.types';
import type { WillCallOrderItemsByEventVo } from '@b2b/types/order/api/will-call-order-detail.type';

class LimitsBannerController {
  static $inject = ['$element'];

  /**
   * Event items from the order event, used to resolve ticket names in violation messages.
   */
  eventItems = input<WillCallOrderItemsByEventVo['items']>([]);

  /**
   * List of violations to display
   */
  violations = input<LimitsViolation[]>([]);

  /**
   * Whether the override/exception is active
   */
  overrideActive = input(false);

  /**
   * Whether to show the exception button
   */
  showExceptionButton = input(true);

  /**
   * Whether limits have been checked (to show success message)
   */
  limitsChecked = input(false);

  /**
   * Called when the user clicks "Make Exception" or "Undo Exception"
   */
  onToggleOverride = output<void>();

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-limits-banner');
  }

  hasViolations(): boolean {
    return Array.isArray(this.violations) && this.violations.length > 0;
  }

  isSuccess(): boolean {
    return !!this.limitsChecked && !this.hasViolations();
  }

  isError(): boolean {
    return this.hasViolations() && !this.overrideActive;
  }

  handleToggleOverride() {
    this.onToggleOverride();
  }

  /**
   * Formats a violation for display
   */
  formatViolation(violation: LimitsViolation): string {
    const eventitems = this.eventItems || [];
    const allowed = violation.allowedQuantity;
    const timeFrame = violation.timeFrame.toLowerCase() === 'lifetime' ? 'event' : violation.timeFrame;

    // combined ticket types
    if (violation.pricePointIds?.length && violation.pricePointIds.length > 1){
      const tickets = violation.pricePointIds.map((id) => {
        const ticket = eventitems.find((item) => item.ticketTypeId === id);
        return ticket ? ticket.itemTypeName : undefined;
      }).filter(Boolean).join(', ');
      return `${allowed} combined per ${timeFrame}: ${tickets}`;
    }

    // single ticket type
    const ticket = eventitems.find((item) => item.ticketTypeId === violation.pricePointId || item.ticketTypeId === violation.pricePointIds?.[0]);
    return `${allowed} per ${timeFrame}: ${ticket?.itemTypeName}`;
  }
}

export const LimitsBannerComponentModule = angular
  .module('acme.common.component.limits-banner', [])
  .component('acmeLimitsBanner', {
    templateUrl: 'common/components/limits-banner/limits-banner.component.tpl.html',
    controller: LimitsBannerController,
    controllerAs: '$ctrl',
    bindings: {
      eventItems: '<',
      violations: '<',
      overrideActive: '<',
      showExceptionButton: '<',
      limitsChecked: '<',
      onToggleOverride: '&',
    },
  }).name;

